/* eslint-disable import/prefer-default-export */
import { ToastOptions } from 'react-toastify'

export const toastOptions: ToastOptions = {
  autoClose: 2500,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false
}
